import { createReducer, on } from '@ngrx/store';
import * as UserInviteActions from '../actions/user-invite.actions';
import {CreateUserResponse} from '../../../services/api/users/user.model';

export const userInviteFeatureKey = 'userInvite';

export interface State {
  record: CreateUserResponse | null;
  error: unknown | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(UserInviteActions.sendUserInvite, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(UserInviteActions.sendUserInviteSuccess, (_state: State, action: { data: CreateUserResponse }) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(UserInviteActions.sendUserInviteFailure, (_state: State, action: { error: unknown }) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(UserInviteActions.clearUserInviteState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
